<template>
  <default-view>
    <template v-slot:toolbarBtn="links">
      <v-btn
        fab
        small
        :href="links.default.redirectLink"
        dark
        color="white"
        target="_blank"
        title="Ajouter une intervention"
        v-if="links.default.completeName"
      >
        <v-icon color="primary" large>mdi-qrcode</v-icon> </v-btn
      ><i class="pa-1"></i>
      <v-btn
        fab
        small
        :href="links.default.redirectLink2"
        dark
        color="white"
        target="_blank"
        title="Ajouter un index de comptage"
        v-if="links.default.completeName"
      >
        <v-icon color="primary" large>mdi-chart-bar</v-icon>
      </v-btn>
    </template>
    <v-row align="start" no-gutters justify="center" class="fill-height mx-n3">
      <v-col cols="12">
        <onglet-technique> </onglet-technique>
      </v-col>
    </v-row>
  </default-view>
</template>
<script>
import OngletTechnique from "../components/technique/Onglet";
import DefaultView from "../components/DefaultView";

export default {
  components: { OngletTechnique, DefaultView }
};
</script>
